import React from 'react';
import { Link } from 'react-router-dom';
import { Film, Archive, Heart, Users } from 'lucide-react';
export function About() {
  return <div className="min-h-screen bg-[#0a0a0a]" data-id="element-184">
      {/* Hero Section */}
      <div className="relative bg-[#050505] py-20 border-b border-[#222]" data-id="element-185">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-[#D22B2B] to-transparent opacity-50" data-id="element-186"></div>

        <div className="container mx-auto px-4" data-id="element-187">
          <div className="max-w-4xl mx-auto text-center" data-id="element-188">
            <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 border border-[#333] bg-black/50 backdrop-blur-md rounded-full" data-id="element-189">
              <Film className="w-3 h-3 text-[#D22B2B]" data-id="element-190" />
              <span className="font-serif uppercase tracking-[0.3em] text-[10px] text-gray-400" data-id="element-191">
                О проекте
              </span>
            </div>

            <h1 className="font-noir text-5xl md:text-7xl font-medium text-white mb-6 tracking-tight" data-id="element-192">
              Цифровой архив <br data-id="element-193" />
              <span className="text-[#D22B2B]" data-id="element-194">советского кино</span>
            </h1>

            <p className="text-lg text-gray-400 font-serif font-light leading-relaxed" data-id="element-195">
              Сохраняем наследие великой киноэпохи для будущих поколений
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16" data-id="element-196">
        <div className="max-w-4xl mx-auto space-y-16" data-id="element-197">
          {/* Mission Section */}
          <section className="bg-[#141414] p-8 md:p-12 border-l-2 border-[#D22B2B] relative shadow-2xl" data-id="element-198">
            <div className="flex items-start gap-6 mb-6" data-id="element-199">
              <div className="p-3 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full shadow-[0_0_15px_rgba(210,43,43,0.2)]" data-id="element-200">
                <Archive className="w-6 h-6" data-id="element-201" />
              </div>
              <div data-id="element-202">
                <h2 className="font-noir text-3xl text-white mb-4 tracking-wide" data-id="element-203">
                  Наша миссия
                </h2>
                <p className="text-gray-300 font-serif leading-relaxed mb-4" data-id="element-204">
                  KINOSOVETY — это цифровой архив советского киноискусства,
                  созданный с целью сохранения и популяризации культурного
                  наследия великой киноэпохи. Мы собираем, систематизируем и
                  делаем доступными фильмы, которые составляют золотой фонд
                  отечественного кинематографа.
                </p>
                <p className="text-gray-300 font-serif leading-relaxed" data-id="element-205">
                  Каждый фильм в нашей коллекции — это не просто развлечение, а
                  часть истории, отражение времени, художественное произведение,
                  которое заслуживает бережного отношения и внимания
                  современного зрителя.
                </p>
              </div>
            </div>
          </section>

          {/* Features Grid */}
          <section className="grid md:grid-cols-2 gap-8" data-id="element-206">
            <div className="bg-[#141414] p-8 border border-[#333] hover:border-[#D22B2B]/50 transition-colors duration-300" data-id="element-207">
              <div className="flex items-center gap-4 mb-4" data-id="element-208">
                <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full" data-id="element-209">
                  <Film className="w-5 h-5" data-id="element-210" />
                </div>
                <h3 className="font-noir text-xl text-white" data-id="element-211">
                  Полная коллекция
                </h3>
              </div>
              <p className="text-gray-400 font-serif text-sm leading-relaxed" data-id="element-212">
                Тысячи фильмов от классики до редких жемчужин советского
                кинематографа, систематизированные по жанрам, годам и
                киностудиям.
              </p>
            </div>

            <div className="bg-[#141414] p-8 border border-[#333] hover:border-[#D22B2B]/50 transition-colors duration-300" data-id="element-213">
              <div className="flex items-center gap-4 mb-4" data-id="element-214">
                <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full" data-id="element-215">
                  <Archive className="w-5 h-5" data-id="element-216" />
                </div>
                <h3 className="font-noir text-xl text-white" data-id="element-217">
                  Официальные описания
                </h3>
              </div>
              <p className="text-gray-400 font-serif text-sm leading-relaxed" data-id="element-218">
                Все описания фильмов взяты из официальных каталогов киностудий и
                архивов, сохраняя аутентичность и историческую точность.
              </p>
            </div>

            <div className="bg-[#141414] p-8 border border-[#333] hover:border-[#D22B2B]/50 transition-colors duration-300" data-id="element-219">
              <div className="flex items-center gap-4 mb-4" data-id="element-220">
                <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full" data-id="element-221">
                  <Heart className="w-5 h-5" data-id="element-222" />
                </div>
                <h3 className="font-noir text-xl text-white" data-id="element-223">Персонализация</h3>
              </div>
              <p className="text-gray-400 font-serif text-sm leading-relaxed" data-id="element-224">
                Создавайте личные списки, получайте рекомендации на основе ваших
                предпочтений и следите за историей просмотров.
              </p>
            </div>

            <div className="bg-[#141414] p-8 border border-[#333] hover:border-[#D22B2B]/50 transition-colors duration-300" data-id="element-225">
              <div className="flex items-center gap-4 mb-4" data-id="element-226">
                <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full" data-id="element-227">
                  <Users className="w-5 h-5" data-id="element-228" />
                </div>
                <h3 className="font-noir text-xl text-white" data-id="element-229">Для всей семьи</h3>
              </div>
              <p className="text-gray-400 font-serif text-sm leading-relaxed" data-id="element-230">
                Удобная фильтрация по возрастным категориям позволяет подобрать
                фильмы для семейного просмотра с детьми любого возраста.
              </p>
            </div>
          </section>

          {/* History Section */}
          <section className="border-t border-[#222] pt-12" data-id="element-231">
            <h2 className="font-noir text-3xl text-white mb-8 tracking-wide" data-id="element-232">
              История проекта
            </h2>
            <div className="space-y-6 text-gray-300 font-serif leading-relaxed" data-id="element-233">
              <p data-id="element-234">
                Проект KINOSOVETY был запущен в 2024 году группой энтузиастов и
                киноведов, объединенных любовью к советскому кинематографу. Мы
                начали с идеи создать удобный цифровой каталог, который бы помог
                современному зрителю ориентироваться в огромном наследии
                советского кино.
              </p>
              <p data-id="element-235">
                Сегодня наша коллекция включает фильмы всех крупнейших
                киностудий СССР — от Мосфильма и Ленфильма до республиканских
                студий. Мы продолжаем расширять архив, добавляя редкие и
                малоизвестные картины, которые заслуживают внимания.
              </p>
              <p className="text-sm text-gray-500 italic border-l-2 border-[#333] pl-6" data-id="element-236">
                Noir Collection — специальная версия сайта, вдохновленная
                эстетикой классического нуар-кино, создана для тех, кто ценит
                атмосферу и визуальную культуру кинематографа.
              </p>
            </div>
          </section>

          {/* CTA Section */}
          <section className="bg-[#141414] p-8 md:p-12 border border-[#333] text-center" data-id="element-237">
            <h2 className="font-noir text-3xl text-white mb-4 tracking-wide" data-id="element-238">
              Присоединяйтесь к нам
            </h2>
            <p className="text-gray-400 font-serif mb-8 max-w-2xl mx-auto" data-id="element-239">
              Создайте аккаунт, чтобы получить доступ к персональным
              рекомендациям, спискам и полной коллекции фильмов.
            </p>
            <Link to="/login" className="inline-flex items-center justify-center h-11 px-6 text-sm uppercase tracking-widest font-serif bg-[#D22B2B] text-white border border-[#D22B2B] shadow-[0_0_15px_rgba(210,43,43,0.3)] hover:shadow-[0_0_25px_rgba(210,43,43,0.5)] hover:bg-[#b01e1e] transition-all duration-300" data-id="element-240">
              Войти в профиль
            </Link>
          </section>
        </div>
      </div>
    </div>;
}